import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const AsyncCreateCustomView = Loadable({
  loader: () => import( /* webpackChunkName: "create-custom-view" */'./CreateCustomView'),
  // don't render a loading spinner for this because it's a UIModalPanel
  LoadingComponent: () => null
});
export default AsyncCreateCustomView;